<template>
  <div class="job-item">
    <div class="job-item__icon-container mr-5">
      <v-img
        src="@/assets/svg/booking-icon.svg"
        class="job-item__icon-container__icon"
        size="50"
        label="Booking Icon"
      />
    </div>
    <div class="job-item__label">
      <div class="job-item__label__title">
        {{ `${title ? title : template.jobTitle}` }}
      </div>
      <Permissioned section="bookings.view">
        <div class="job-item__label__subtitle">
          <div permission="contract-type">
            {{ template.contractType }}
          </div>
          <div permission="working-hours">
            <span class="ml-1"> | </span>
            {{ template.workingHours || "-" }}
          </div>
          <div :oneOfPermissions="salaryBandPermissions">
            <span class="ml-1"> | </span>
            {{ template.salaryBandLower | currency("GBP") }} -
            {{ template.salaryBandUpper | currency("GBP") }}
          </div>
        </div>
      </Permissioned>
    </div>
  </div>
</template>

<script>
import Permissioned from "@/components/common/Permissioned";

export default {
  name: "JobItem",
  data() {
    return {
      hovered: false,
      salaryBandPermissions: ["salary-band-upper", "salary-band-lower"]
    };
  },
  components: {
    Permissioned
  },
  props: {
    template: {
      type: Object,
      required: true
    },
    title: String
  }
};
</script>

<style scoped lang="scss">
.job-item__label {
  &__title {
    font-weight: bold;
  }

  &__subtitle {
    width: 100%;
    position: relative;
  }

  &__subtitle > * {
    float: left;
  }
}
</style>
